import api from '.';

export const _getCEP = async (cep) => {
    return await api.get(`utils/cep/${cep}`).then(response => { return response });
}